const getWeatherColor = async (debug) => {

  if (!debug) {
    const storedColor = getWeatherColorFromStorage();
    if (storedColor) return storedColor;
  }
  const newColor = await getNewWeatherColor(debug);
  setWeatherColorToStorage(newColor);
  return newColor;
};

const getWeatherColorFromStorage = () => {
  let storedColor = localStorage.getItem('currentColorMood');
  if (!storedColor) return false;
  storedColor = JSON.parse(storedColor);
  if (Date.now() > storedColor.timestamp + 60 * 60 * 1000) return false; // if stored value is older than one hour
  return storedColor.color;
};

const setWeatherColorToStorage = (color) => {
  localStorage.setItem('currentColorMood', JSON.stringify({color: color, timestamp: Date.now()}));
};

const getNewWeatherColor = async (debug) => {

  const location = await getLocation(debug);
  const weather = await getWeather(location, debug);
  const temprature = weather.main.temp;
  const colors = ['#abd2ee', '#1e72ea', '#31dda3', '#ffd800', '#b730f7', '#e84a32'];
  const index = Math.round(map(temprature, -5, 30, 0, colors.length - 1));
  const hex = colors[index];

  if (debug) {
    console.log(temprature + ' degrees');
    console.log('index: ' + index);
    console.log(`Color: ${hex}`);
    console.log(`Location: ${location}`);
    console.log(`Temperature: ${temprature}`);
    console.log(`index: ${index}`);
    console.log(`hex: ${hex}`);
  }
  return hex;
};

const getLocation = async (debug) => {
  let url = 'https://ipapi.co/json/';

  return await fetch(url, {
    method: 'get',
    mode: 'cors', // no-cors, *cors, same-origin
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(function (response) {
      return response.json();
    })
    .then(data => {
      if (debug) console.log(data);
      return `${data.city}, ${data.country_code}`;
    })
    .catch(error => {
      console.log(error);
      return `Groningen,NL`;
    });
};

const getWeather = async (location, debug) => {
  return await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${location}&units=metric&appid=2d48b1d7080d09ea964e645ccd1ec93f`, {
    method: 'GET',
  })
    .then(response => {
      return response.json();
    })
    .then(data => {
      if (debug) console.log(data);
      return data;
    })
    .catch(error => {
      console.log(error);
      return {main: {temp: 15.95}};
    });

};

const map = (value, x1, y1, x2, y2) => (value - x1) * (y2 - x2) / (y1 - x1) + x2;

export {getWeatherColor};

